import dataSources from "dataSources";
import { batch } from "react-redux";
import { STATUS_LOADING } from "common/constants";
import { getResponseError } from "common/utils/index";

import slice from "../reducer/slice";
import { applicationActions } from "entities/application";
import { GetHistoryUserLocationForm } from "entities/users";
import { AppThunk } from "store";

const { setHistoryUserLocation, setHistoryUserLocationLoading } = slice.actions;
const { setErrorNotice } = applicationActions;
type TOperation = (form: GetHistoryUserLocationForm) => AppThunk;

const operation: TOperation =
  (form: GetHistoryUserLocationForm) => async (dispatch: any) => {
    try {
      dispatch(setHistoryUserLocationLoading(STATUS_LOADING.load));

      const { usersLocations } =
        await dataSources.userLocation.getUSerHistoryLocations(form);

      batch(() => {
        dispatch(setHistoryUserLocationLoading(STATUS_LOADING.done));
        dispatch(setHistoryUserLocation(usersLocations));
      });
    } catch (e) {
      const error = await getResponseError(e);
      dispatch(setErrorNotice(error));
      dispatch(setHistoryUserLocationLoading(STATUS_LOADING.error));
    }
  };

export default operation;
